"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.DimmerContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var DimmerContainer = _styledComponents.default.div.withConfig({
  displayName: "DimmerContainer",
  componentId: "sc-okoliw-0"
})(["position:", ";top:0;left:0;width:100%;height:100%;z-index:2000;display:flex;flex-direction:column;justify-content:center;align-items:center;background-color:white;opacity:.8;"], function (props) {
  return props.fullPage ? "fixed" : "absolute";
});

exports.DimmerContainer = DimmerContainer;
DimmerContainer.propTypes = {
  fullPage: _propTypes.default.bool
};